import { createFileRoute } from '@tanstack/react-router'
import { LoginScreen } from '@/components/auth/login-screen'

/**
 * `?next=` — where to land after signing in.
 *
 * Attached by the root auth gate when it turns someone away from a deep link.
 * Validated here rather than read ad hoc, so the screen receives a typed value
 * and the redirect that produces it is checked against this shape.
 *
 * The old version of this route needed a `<Suspense>` boundary around the
 * screen, because reading search params forced a statically prerendered route
 * to bail out to client rendering and the build failed without somewhere to
 * bail out TO. Nothing prerenders now, so the boundary is gone.
 */
export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { next?: string } =>
    typeof search.next === 'string' ? { next: search.next } : {},
  head: () => ({ meta: [{ title: 'Sign in — Constellation QR' }] }),
  component: LoginScreen,
})
